
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 21 21","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M3 19h15.467M4.422 15.8h1.956a.356.356 0 01.355.356V19H4.067v-2.844a.356.356 0 01.355-.356zM9.756 9.4h1.955a.355.355 0 01.356.356V19H9.4V9.756a.356.356 0 01.356-.356zM15.089 12.6h1.955a.356.356 0 01.356.356V19h-2.667v-6.044a.356.356 0 01.356-.356zM17.933 6.2V3h-3.2","stroke":"currentColor","stroke-width":"1.5","stroke-linecap":"round","stroke-linejoin":"round"}}),_c('path',{attrs:{"d":"M17.933 3l-3.59 3.591a1.599 1.599 0 01-1.591.401l-4.06-1.085a1.6 1.6 0 00-1.545.415L3 10.469","stroke":"currentColor","stroke-width":"1.5","stroke-linecap":"round","stroke-linejoin":"round"}})])
          )
        }
      }
    